import { IconChevronLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const PageHeaderComponent = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-4 md:gap-6"
    >
      <IconChevronLeft size={24} />
      <span className="font-semibold text-neutral-800 md:text-3xl">
        Confirm and pay
      </span>
    </button>
  );
};

export default PageHeaderComponent;
